import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import IInternalUserAccessScope from '../../interfaces/IInternalUserAccessScope';
import { IPaginationReturn } from '../../interfaces/IPaginationReturn';

export const useInternalUserAccessScopeService = () => {
  const request = useRequest<IInternalUserAccessScope>();
  const path = 'user/scope';

  const listById = async (id: string): Promise<IInternalUserAccessScope> => {
    return await request
      .getOne({ path: `${path}/${id}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listByUserId = async (
    id: string,
    queryParams: string,
  ): Promise<IPaginationReturn<IInternalUserAccessScope[]>> => {
    return await request
      .getManyPaginated({ path: `${path}/by-user-id/${id}?${queryParams}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async (resource: IInternalUserAccessScope): Promise<IInternalUserAccessScope> => {
    return await request
      .post({
        path: `${path}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: string, resource: IInternalUserAccessScope): Promise<IInternalUserAccessScope> => {
    return await request
      .put({
        path: `${path}/${id}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: string): Promise<void> => {
    return await request
      .remove({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(() => {})
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { listByUserId, listById, create, update, remove };
};
